import * as stylex from "@stylexjs/stylex";
export const styles = {
  shell: {
    kAzted: "xg6iff7",
    kWkggS: "x1nt9cj2",
    kMwMTN: "x11c6llc",
    kMv6JI: "x1b5zmvi",
    $$css: true
  },
  header: {
    kAzted: "x1r3qdcx",
    kg3NbH: "xj7an9n",
    kWkggS: "xohx9e",
    kMwMTN: "x1f7m26b",
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kjj79g: "x1qughib",
    kOIVth: "x1c1vhfx",
    kwnvtZ: "x1a02dak",
    $$css: true
  },
  brand: {
    kGuDYH: "x1i1m3gp",
    k63SB2: "x19s9jnd",
    kb6lSQ: "x1roq8pg",
    kybGjl: "x1hl2dhg",
    kMwMTN: "x1f7m26b",
    $$css: true
  },
  nav: {
    k1xSpc: "x78zum5",
    kOIVth: "x167g77z",
    kGNEyG: "x6s0dn4",
    kwnvtZ: "x1a02dak",
    $$css: true
  },
  navLink: {
    kMwMTN: "x4bg21v",
    k8WAf4: "xp59q4u",
    kg3NbH: "xqin4a2",
    kybGjl: "x1hl2dhg",
    kaIpWk: "x1kogg8i",
    kGuDYH: "xif65rj",
    kGzVvX: "x1pnhqlj",
    kDPRdz: "x1iih0q2",
    k3Woio: "x119fsv9",
    kiEn40: "x7s97pk",
    $$css: true
  },
  active: {
    kMwMTN: "x1f7m26b",
    kWkggS: "xmn4o3z",
    $$css: true
  },
  identity: {
    k8WAf4: "x1vvogim",
    kGuDYH: "xfifm61",
    kMwMTN: "x1ww0zgn",
    $$css: true
  },
  main: {
    ks0D6T: "xjx7936",
    kUOVxO: "xvueqy4",
    kmVPX3: "x1gkjlqi x1yq9xv2",
    $$css: true
  },
  pageHeading: {
    k1xSpc: "x78zum5",
    kGNEyG: "x7a106z",
    kjj79g: "x1qughib",
    kOIVth: "x1c1vhfx",
    k1K539: "x1chd833",
    kwnvtZ: "x1a02dak",
    $$css: true
  },
  title: {
    kGuDYH: "x1s3cmhv",
    kLWn49: "x1u7k74",
    kb6lSQ: "xipi2l9",
    k63SB2: "x1s688f",
    k1K539: "xyorhqc",
    $$css: true
  },
  description: {
    kMwMTN: "x12qlb6j",
    kGuDYH: "x1jvydc1",
    kLWn49: "x1dbl2gt",
    ks0D6T: "x7ep2pv",
    $$css: true
  },
  panel: {
    kWkggS: "x83z2og",
    kaIpWk: "x1q4ynmn",
    kmVPX3: "xor4a8r",
    k1K539: "x1hq5gj4",
    $$css: true
  },
  panelHeading: {
    kGuDYH: "xosj86m",
    k63SB2: "x1s688f",
    k1K539: "x1yztbdb",
    $$css: true
  },
  grid: {
    k1xSpc: "xrvj5dj",
    kumcoG: "x4bqi9s x1s4i0j0",
    kOIVth: "x1665zp3",
    $$css: true
  },
  form: {
    k1xSpc: "xrvj5dj",
    kumcoG: "x1o61qjw x1nc4n6v",
    kOIVth: "xaobbuh",
    $$css: true
  },
  field: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x167g77z",
    kGuDYH: "x4z9k3i",
    $$css: true
  },
  select: {
    kaIpWk: "x1kogg8i",
    kWkggS: "x12peec7",
    kmVPX3: "x7z7khe",
    kVVagm: "xln7xf2",
    kAzted: "x141feeh",
    $$css: true
  },
  full: {
    kBCFzs: "x1osaytk",
    $$css: true
  },
  formContainer: {
    keoZOQ: "x1sy10c2",
    $$css: true
  },
  headerButton: {
    kWkggS: "x1c5tqo3",
    kMwMTN: "x7o6ztl",
    $$css: true
  },
  actions: {
    k1xSpc: "x78zum5",
    kOIVth: "x883omv",
    kGNEyG: "x6s0dn4",
    kwnvtZ: "x1a02dak",
    keoZOQ: "xw7yly9",
    $$css: true
  },
  notice: {
    kmVPX3: "x1tamke2",
    kaIpWk: "xu4hgxq",
    kWkggS: "x14bbs7j",
    kMwMTN: "x1q927o6",
    k1K539: "x91k8ka",
    kLWn49: "x1evy7pa",
    $$css: true
  },
  error: {
    kmVPX3: "x1tamke2",
    kaIpWk: "xu4hgxq",
    kWkggS: "x1hbmi36",
    kMwMTN: "x1apr549",
    k1K539: "xieb3on",
    $$css: true
  },
  status: {
    k1xSpc: "x3nfvp2",
    k8WAf4: "x12ulsxz",
    kg3NbH: "x1q4txso",
    kaIpWk: "x12oqio5",
    kGuDYH: "xfifm61",
    kWkggS: "x1ozmnm8",
    kMwMTN: "x7x2if2",
    khDVqt: "xuxw1ft",
    $$css: true
  },
  applied: {
    kWkggS: "x15hawuu",
    kMwMTN: "xeg2101",
    $$css: true
  },
  failed: {
    kWkggS: "x1hbmi36",
    kMwMTN: "x1apr549",
    $$css: true
  },
  tableWrap: {
    kXHlph: "xw2csxc",
    $$css: true
  },
  table: {
    kzqmXN: "xh8yej3",
    kLvRdT: "x1mwwwfo",
    k9WMMc: "xdpxx8g",
    kGuDYH: "xif65rj",
    $$css: true
  },
  th: {
    k8WAf4: "x10dr8xq",
    kg3NbH: "xqin4a2",
    kGuDYH: "xfifm61",
    k63SB2: "x1s688f",
    kMwMTN: "xkuzkr5",
    kWkggS: "xt040g",
    $$css: true
  },
  td: {
    k8WAf4: "x1xn8qrt",
    kg3NbH: "xqin4a2",
    kXLuUW: "x16dsc37",
    kLWn49: "x1evy7pa",
    $$css: true
  },
  code: {
    kMv6JI: "x17kntyo",
    kGuDYH: "x4z9k3i",
    kmVPX3: "x1tamke2",
    kaIpWk: "x1kogg8i",
    kWkggS: "x15xle5e",
    kXHlph: "xw2csxc",
    kLWn49: "xwxc2jc",
    kqGvvJ: "x2i9t41",
    $$css: true
  },
  small: {
    kGuDYH: "xfifm61",
    kMwMTN: "xkuzkr5",
    kLWn49: "x1dbl2gt",
    $$css: true
  },
  empty: {
    k8WAf4: "xxtzvbg",
    k9WMMc: "x2b8uid",
    kMwMTN: "xkuzkr5",
    $$css: true
  },
  login: {
    ks0D6T: "x1lwm3bp",
    kUOVxO: "xvueqy4",
    kLKAdn: "x15imoyu",
    $$css: true
  }
};